var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 13.5C1.3 13.5 0.875 13.325 0.525 12.975C0.175 12.625 0 12.2 0 11.7V2.3C0 1.8 0.175 1.375 0.525 1.025C0.875 0.675 1.3 0.5 1.8 0.5H17.2C17.7 0.5 18.125 0.675 18.475 1.025C18.825 1.375 19 1.8 19 2.3V11.7C19 12.2 18.825 12.625 18.475 12.975C18.125 13.325 17.7 13.5 17.2 13.5H1.8ZM1.8 12H17.2C17.2667 12 17.3333 11.9667 17.4 11.9C17.4667 11.8333 17.5 11.7667 17.5 11.7V2.3C17.5 2.23333 17.4667 2.16667 17.4 2.1C17.3333 2.03333 17.2667 2 17.2 2H1.8C1.73333 2 1.66667 2.03333 1.6 2.1C1.53333 2.16667 1.5 2.23333 1.5 2.3V11.7C1.5 11.7667 1.53333 11.8333 1.6 11.9C1.66667 11.9667 1.73333 12 1.8 12ZM5.625 10.875H13.375V9.125H5.625V10.875ZM2.625 7.875H4.375V6.125H2.625V7.875ZM5.625 7.875H7.375V6.125H5.625V7.875ZM8.625 7.875H10.375V6.125H8.625V7.875ZM11.625 7.875H13.375V6.125H11.625V7.875ZM14.625 7.875H16.375V6.125H14.625V7.875ZM2.625 4.875H4.375V3.125H2.625V4.875ZM5.625 4.875H7.375V3.125H5.625V4.875ZM8.625 4.875H10.375V3.125H8.625V4.875ZM11.625 4.875H13.375V3.125H11.625V4.875ZM14.625 4.875H16.375V3.125H14.625V4.875Z",
    fill: "#090C10",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.7fe0f31cf97f63b30649ed383287d36c.svg";
export { ForwardRef as ReactComponent };